import React from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import { Training } from '~/training/types';

export type HeaderComponent = React.FC<{ status: Training['status'] }>;

const Header: HeaderComponent = ({ status }) => {
  const { t } = useTranslation('training');

  return (
    <div className={classes['model-header']}>
      <div className={classes['header-content']}>
        <label className={classes['title']}>
          {`${t('status.' + status)} ${t('training')}`}
        </label>
      </div>
    </div>
  );
};

export default Header
